<template>
  <v-dialog v-model="show" persistent @keydown.esc="hide" width="500">
    <v-card data-test="employee-selector">
      <v-form ref="form">
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ title }}
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="selectedId"
            :items="employees"
            required
            item-value="id"
            :rules="[rules.required]"
            :item-text="itemText"
            data-test="employee-selector-items"
          />
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey" text @click="hide">
            {{ $t("dialog.cancel") }}
          </v-btn>

          <v-btn
            @click="save"
            color="primary"
            text
            :loading="loading"
            data-test="employee-selector-change"
            >{{ $t("dialog.assign") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import EmployeeNamesQuery from "../graphql/EmployeeNames.gql";

export default {
  props: ["title", "id", "show", "loading"],
  data() {
    return {
      employees: [],
      selectedId: null,
      rules: {
        required: (value) => !!value || this.$i18n.t("validation.required"),
      },
    };
  },
  watch: {
    id() {
      this.selectedId = this.id;
    },
  },
  methods: {
    hide() {
      this.selectedId = null;
      this.$refs.form.reset();
      this.$emit("update:loading", false);
      this.$emit("update:show", false);
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$emit("update:loading", true);
        this.$emit("change", this.selectedId);
        this.selectedId = null;
        this.$refs.form.reset();
      }
    },
    itemText(e) {
      const f = this.$options.filters;
      return `${f.name(e)} ${f.idBrackets(e.id)}`;
    },
  },
  apollo: {
    employees: {
      query: EmployeeNamesQuery,
      variables() {
        return {
          queryAll: true,
          queryAllShifts: true,
        };
      },
      skip() {
        return !this.show;
      },
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>
